<template>
  <el-dialog
    :title="managerId < 0 ? '新增管理员' : '编辑管理员权限'"
    :visible="managersDialogType == 'setting'"
    :close-on-click-modal="false"
    :before-close="closeDialog"
    @open="initDialog"
    width="50%"
  >
    <div>
      <el-form
        label-position="right"
        label-width="150px"
        :model="managerDetails"
      >
        <el-form-item label="用户名">
          <el-input
            v-model="managerDetails.user_name"
            v-if="managerId < 0"
          ></el-input>
          <span v-else>{{ managerDetails.user_name }}</span>
        </el-form-item>
        <el-form-item label="真实姓名">
          <el-input
            v-model="managerDetails.real_name"
            v-if="managerId < 0"
          ></el-input>
          <span v-else>{{ managerDetails.real_name }}</span>
        </el-form-item>
        <el-form-item label="权限设置" v-if="managerId > 0">
          <p v-for="item in allAuthCode" :key="item.auth_code">
            <el-checkbox v-model="item.isSelect">{{
              item.menu_name
            }}</el-checkbox>
          </p>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="success" @click="saveAuthority" :loading="isLoading"
        >保 存</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import {
  managerAllAuthCode,
  managerAuthorityList,
  managerupdateAuthority,
  managerAddManager,
} from '@/api/manager'
export default {
  components: {},
  data() {
    return {
      allAuthCode: [],
      isLoading: false,
      managerDetails: {},
    }
  },
  props: {
    managersDialogType: {},
    managerId: {
      default: 0,
    },
    managerInfo: {},
  },
  mounted() {
    if (this.managerId != 0) {
      this.initDialog()
    }
  },
  methods: {
    // 关闭模态框
    closeDialog() {
      this.managerDetails = {}
      this.$emit('update:managersDialogType', '')
    },
    // 初始化模态框
    initDialog() {
      this.initManagerSetting()
    },
    // 获取所有权限列表,并对比已有权限
    async getAllAuthCodeList(_authArr) {
      let { code, result } = await managerAllAuthCode()
      if (code == this.CONFIG.CODE_SUCCESS) {
        for (let i in result) {
          let item = result[i]
          item.isSelect =
            !(_authArr.indexOf(item.auth_code) < 0) || _authArr === 'all'
        }
        this.allAuthCode = result
      }
    },
    // 初始化用户信息
    initManagerSetting() {
      if (this.managerId < 0) {
        this.managerDetails = {
          user_name: '',
          real_name: '',
        }
        this.getAllAuthCodeList('all')
      } else {
        this.managerDetails = { ...this.managerInfo }
        this.getAuthorityList()
      }
    },
    // 获取用户权限情况
    async getAuthorityList() {
      let { code, result } = await managerAuthorityList({
        manager_id: this.managerId,
      })
      if (code == this.CONFIG.CODE_SUCCESS) {
        let authList = []
        if (result) {
          authList = result.map((item) => item.auth_code)
        }
        this.getAllAuthCodeList(authList)
      }
    },
    saveAuthority() {
      if (this.managerId < 0) {
        this.addManager()
      } else {
        this.updateAuthority()
      }
    },
    async addManager() {
      let postData = { ...this.managerDetails }
      this.isLoading = true
      let { code, msg } = await managerAddManager(postData)
      this.isLoading = false
      if (code == this.CONFIG.CODE_SUCCESS) {
        this.$emit('updateManagersList')
        this.closeDialog()
        this.$message({
          type: 'success',
          message: msg,
        })
      }
    },
    async updateAuthority() {
      let authority_code = []
      for (let i in this.allAuthCode) {
        let item = this.allAuthCode[i]
        if (item.isSelect) {
          authority_code.push(item.auth_code)
        }
      }
      let postData = { manager_id: this.managerId, authority_code }
      this.isLoading = true
      let { code, msg } = await managerupdateAuthority(postData)
      this.isLoading = false
      if (code == this.CONFIG.CODE_SUCCESS) {
        this.$emit('updateManagersList')
        this.closeDialog()
        this.$message({
          type: 'success',
          message: msg,
        })
      }
    },
  },
}
</script>

<style lang="less" scoped></style>
